import React, { useContext } from 'react';
import { IAddressBlockProps } from 'src/pages/AccountPage/components/AddressBlock/AddressBlock.i';
import { AccountPagesContext } from 'src/lib/AccountPagesContext';
import { Button, IconStarFilled, Typography } from '@riac/design-system';

export const AddressBlock = ({ addr, formAction, setFormAction, blankForm, setForm, formId, addressTypeList }: IAddressBlockProps) => {
  const { getAddresses, account, countries, addresses } = useContext(AccountPagesContext);

  async function updatePrimary(newID) {
    const oldID = addresses.filter((addr) => addr.AddressType === 'Primary')[0]?.AddressID;
    await fetch(`/api/account/address/makePrimary/${newID}/${oldID || -1}`, {
      credentials: 'include',
      method: 'PUT',
    });
    setTimeout(() => getAddresses(), 5);
  }

  function setFormData() {
    // clicking the edit button on the address already being edited. close form
    if(formAction === 'edit' && formId === addr.AddressID) {
      setFormAction(null);
      setForm(blankForm);
      return;
    }
    // open address form and prefill fields with current data
    setFormAction('edit');
    let newAddressTypeID;
    if(addr.AddressType == 'Primary') {
      newAddressTypeID = 1;
    } else {
      newAddressTypeID = addressTypeList.filter((type) => type.AddressType == addr.AddressType)[0]?.AddressTypeID || 10;
    }
    const newCountryID = countries.filter((country) => country.CountryName === addr.CountryName)[0]?.CountryID || 236;
    setForm({
      AddressType: addr.AddressType,
      AddressTypeID: newAddressTypeID,
      CountryID: newCountryID,
      State: addr.State,
      AddressID: addr.AddressID,
      Address: addr.Address,
      Address2: addr.Address2 || '',
      City: addr.City,
      Zip: addr.Zip,
      Province: addr.Province,
    });
  }

  async function handleDelete(AddressID) {
    await fetch(`/api/account/address/deleteAddress/${AddressID}`, {
      credentials: 'include',
      method: 'POST',
    });
    setTimeout(() => getAddresses(), 5);
    setFormAction(null);
  }

  const { AddressType, Address, Address2, City, State, Province, Zip, CountryName, AddressID } = addr;

  return (
    <div className='pt-5 px-5 gap-1 border-1 border-surface-darker max-w-96 sm:min-w-96 flex-1'>
      <div className='flex flex-col h-full'>
        <div className='flex flex-col gap-1 pb-3 flex-1'>
          <Typography size='sm' color='text-lighter' weight='semibold'>{AddressType}</Typography>
          {account.BusinessName && <Typography weight='medium'>{account.BusinessName}</Typography> || ''}
          <div className=''>
            <Typography>{Address}</Typography>
            <Typography>{Address2 || <span className='select-none'>&nbsp;</span>}</Typography>
            <Typography>{City}, {State} {Province} {Zip}</Typography>
            <Typography>{CountryName}</Typography>
          </div>
        </div>
        <div className='py-3 gap-3 border-t-1 border-surface-darker flex flex-row justify-between items-center'>
          <div className='flex flex-row gap-3 items-center'>
            <Button variant='link' onPress={() => setFormData()}>Edit</Button>
            {AddressType !== 'Primary' &&
              <Button variant='link' className='text-text-error hover:text-error-hover active:text-error-active' onPress={() => handleDelete(AddressID)}>Remove</Button>
            }
          </div>
          {AddressType !== 'Primary' &&
            <Button onPress={() => updatePrimary(AddressID)} title='Make Primary' unstyled className='text-gray-500 hover:text-gold-700 p-1'>
              <IconStarFilled/>
            </Button>
          ||
            <IconStarFilled className='text-gold-500 h-6 w-6'/>
          }
        </div>
      </div>
    </div>
  );
};
